import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from './app';
import { BrowserRouter } from "react-router-dom";
hydrateRoot(document, React.createElement(BrowserRouter, null,
    React.createElement(App, { xApiKey: window.xApiKey, cachedAPI: window.cachedAPI, sseBaseUrl: window.sseBaseUrl, siteConfig: window.app_data, pageData: window.page_data, browserDetails: window.browserDetails, apiBaseUrl: window.apiBaseUrl, analyticsBaseUrl: window.analyticsBaseUrl, wssBaseUrl: window.wssBaseUrl, env: window.env, ip: window.ip })));
